import React from 'react';
import { Card } from '@mui/material';

import {
    InformationCard,
    InformationCardItemProps,
    useModal,
} from '@europrocurement/flexy-components';

import { GroupeTravailUtilisateurApiObject } from '@europrocurement/l2d-domain';
import { Box } from '@mui/system';
import { WorkGroupMembersCard } from './WorkGroupMembersCard/WorkGroupMembersCard';

import { WorkGroupUpdateReferentForm } from '../WorkGroupModals/WorkGroupUpdateReferentForm';
import { WorkGroupUpdateInfosForm } from '../WorkGroupModals/WorkGroupUpdateInfosForm';

export type WorkGroupContainerProps = {
    workgroup: GroupeTravailUtilisateurApiObject;
    isActiveStatus: boolean;
};

export const WorkGroupContainer: React.FunctionComponent<WorkGroupContainerProps> = function ({
    workgroup,
    isActiveStatus,
}) {
    // Get hooks.
    const { modalActions } = useModal();

    /**
     * List workgroup informations
     */
    const groupInfos: Array<InformationCardItemProps> = [
        { label: 'Libellé', value: workgroup.lib },
        { label: 'Domaine', value: workgroup.domaine?.ddmLibelle },
        { label: 'Mail', value: workgroup.email },
        { label: 'Téléphone', value: workgroup.phone },
        {
            label: 'Date de création',
            value: workgroup.dCreation ? new Date(workgroup.dCreation).toLocaleDateString() : '-',
        },
        {
            label: 'Date de clôture',
            value: workgroup.dCloture ? new Date(workgroup.dCloture).toLocaleDateString() : '-',
        },
    ];

    // Update groupe travail infos modal.
    const handleModifyInfo = () => {
        modalActions.call(<WorkGroupUpdateInfosForm workgroup={workgroup} />);
    };

    // Update groupe travail référent modal.
    const handleModifyRef = () => {
        modalActions.call(<WorkGroupUpdateReferentForm workgroup={workgroup} />);
    };

    /**
     * List workgroup referent informations
     */
    const referentInfos: Array<InformationCardItemProps> = [
        {
            label: 'Nom',
            value: `${workgroup.iduserReferent?.prenom} ${workgroup.iduserReferent?.nom}`,
        },
        { label: 'Mail', value: workgroup.iduserReferent?.mail },
    ];

    return (
        <Box
            display="flex"
            justifyContent="space-between"
        >
            <Card sx={{ width: '49%', margin: '10px 0', padding: '0' }}>
                <InformationCard
                    title="Informations du groupe"
                    button={{
                        label: 'Modifier',
                        onClick: handleModifyInfo,
                    }}
                    items={groupInfos}
                />
                <InformationCard
                    title="Référent"
                    button={{
                        label: 'Modifier',
                        onClick: handleModifyRef,
                    }}
                    items={referentInfos}
                />
            </Card>
            <WorkGroupMembersCard
                workgroup={workgroup}
                isActiveStatus={isActiveStatus}
            />
        </Box>
    );
};
